module.exports = __webpack_public_path__ + "static/media/017.43ce701a.jpg";